import { useMsal } from '@azure/msal-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { loginRequest } from '@/auth/authConfig';
import { logger } from '@/services/logger';

/**
 * Component displayed when authentication is required or has failed
 */
export function AuthenticationError() {
  const { instance } = useMsal();

  /**
   * Handle user sign-in attempt
   */
  const handleLogin = () => {
    instance.loginPopup(loginRequest)
      .then(() => {
        // Reload the page to reinitialize the user context
        window.location.reload();
      })
      .catch((e) => {
        logger.error(e, { context: 'LoginRetry' });
      });
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-bold">Authentication Required</CardTitle>
          <CardDescription>
            Your session has expired or authentication failed. Please sign in again to continue.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button onClick={handleLogin} className="w-full">
            Sign in again
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
